import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ApiResponse, GetProviderTagApplicationsResponse } from '@magnetar/admin-api-interfaces'

interface UseProviderTagApplicationsParams {
  tagId: number | null
}

/**
 * 標籤套用頁專用：取得此標籤目前已套用的診所清單（顯示已套用狀態）
 */
export function useProviderTagApplications({ tagId }: UseProviderTagApplicationsParams) {
  const { token } = useAuth()

  const url = token && tagId ? `/api/provider-tags/${tagId}/applications` : null

  const { data, error, isLoading, mutate } = useGet<
    ApiResponse<GetProviderTagApplicationsResponse>
  >(url, undefined, token ?? '')

  return {
    clinics: data?.data?.clinics ?? [],
    isLoading,
    isError: error,
    mutate,
  }
}
